<template>
  <v-dialog
    v-if="!$store.state.stateStream_quiz_show"
    v-model="$store.state.stateStream_survey_show"
    max-width="960px"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    scrollable
    persistent
  >
    <v-card
      ref="card"
      max-height="calc(100vh - 192px)"
      :tile="$vuetify.breakpoint.smAndDown"
    >
      <v-card-title class="purple white--text font-weight-bold justify-center">
        {{ $store.state.stateStream_survey_info.name }}
      </v-card-title>
      <v-card-text class="py-5 black--text">

        <stream-dialog-survey-header ref="header"/>

        <v-form
          ref="form"
          :readonly="$store.state.stateStream_survey_requesting"
        >
          <div
            v-for="(question, i) in $store.state.stateStream_survey_info.question"
            :key="`survey-${ i }`"
            class="mb-8"
          >
            <div
              v-if="question.top_title"
              class="text-body-1 py-2 px-2 font-weight-bold"
            >
              {{ question.top_title }}
            </div>

            <div
              v-if="question.type === 4"
              class="purple lighten-4 py-2 px-3 font-weight-bold"
            >
              {{ question.title }}
            </div>

            <template v-else>
              <div class="grey lighten-2 py-2 px-3 font-weight-bold">
                {{ question.title }}
              </div>

              <v-textarea
                v-if="question.type === 0"
                v-model="question.value"
                class="mt-4"
                :rules="[gc_rules.requiredPollText]"
                rows="3"
                auto-grow
                no-resize
                filled
                dense
              />

              <v-input
                v-else-if="question.type === 2"
                v-model="question.value"
                class="mt-4 px-0 px-md-4"
                :rules="[gc_rules.requiredPollCheckMin, gc_rules.requiredPollCheckMax]"
              >
                <template v-slot:default>
                  <div class="d-flex flex-column">
                    <v-checkbox
                      v-model="question.value"
                      v-for="(text, i2) in question.case"
                      :key="`survey-case-${ i }-${ i2 }`"
                      :label="text"
                      :value="i2"
                      :rules="[gc_rules.requiredPollCheckMin, gc_rules.requiredPollCheckMax]"
                      hide-details
                      dense
                    />
                  </div>
                </template>
              </v-input>

              <v-radio-group
                v-else
                v-model="question.value"
                class="px-0 px-md-4"
                :rules="[gc_rules.requiredPollRadio]"
                :row="!question.orientation"
                dense
              >
                <v-radio
                  v-for="(text, i2) in question.case"
                  :key="`survey-case-${ i }-${ i2 }`"
                  :label="text"
                  :value="i2"
                />
              </v-radio-group>
            </template>

          </div>
        </v-form>

        <v-btn
          @click="submit"
          class="mt-5 mx-auto d-block"
          width="128px"
          :loading="$store.state.stateStream_survey_requesting"
          outlined
        >제출</v-btn>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import env from '../../plugins/process.env'
import axios from '../../plugins/axios'
import StreamDialogSurveyHeader from './StreamDialogSurveyHeader'

export default {
  name: 'StreamDialogSurvey',

  components: {
    StreamDialogSurveyHeader
  },

  methods: {
    submit() {
      const valid1 = this.$refs.header.validate()
      const valid2 = this.$refs.form.validate()
      const valid = valid1 && valid2
      if (valid) {
        return this.submit_axios()
      }
      const target = this.$refs.card.$el
      setTimeout(() => {
        target.querySelector('.error--text')?.scrollIntoView()
      }, 100)
    },
    submit_axios() {
      const it = this
      const info = this.$store.state.stateStream_survey_info
      const header = info.survey_type === 0 ?
        this.$store.state.stateStream_survey_form_header : {}
      const params = {
        answer: info.question
          .map(item => item.value)
          .filter(v => v !== null),
        ...header
      }

      this.$store.state.stateStream_survey_requesting = true

      return axios({
        method: 'POST',
        baseURL: env.API_BASE_URL,
        url: `/api/v1/response_poll/${ info.id }`,
        params
      }).then( result => {
        const state = result.data.code

        if (state !== 200) { throw state }

        it.gm_alertOpen({
          text: '성공적으로 제출 되었습니다.',
          callback: () => it.$store.state.stateStream_survey_show = false
        })
      }).catch(error => {
        it._api_error(`code: ${error}\nat: api_streamDialogSurveySubmit`)
      }).finally( () => {
        it.$store.state.stateStream_survey_requesting = false
      })
    }
  }
}
</script>

<style scoped>

</style>